// 引入路由实例
import router from './index'
import store from '@/store'
/**
 * 路由全局前置守卫
 * 权限逻辑：
 * 1. 无token：仅可访问 isLogin: false 页面，访问需要登录页面强制跳转登录页
 * 2. 有token：可正常访问所有页面（isLogin:true / false 均可）
 * 3. 登录页已登录则自动跳首页，避免重复登录
 * 修复循环重定向报错：增加终止守卫判断，避免无限跳转
 */
router.beforeEach((to, from, next) => {
	document.title = to.meta.name ?? '国联易拍：数智盘活资产，一站式拍卖服务平台'
	// 页面跳转，清空所有加载遮罩，防止卡死
	// store.dispatch('mask/clearAllLoading')
	// 获取本地token（兼容 localStorage / sessionStorage，可自行修改）
	const token = localStorage.getItem('token') || store.getters['user/getUserToken']
	// 目标页面是否需要登录权限
	const needLogin = to.meta.isLogin

	// 修复核心：如果已经是跳转登录页，直接放行，终止守卫递归
	if (to.path === '/login') {
		// 已登录禁止进登录页，跳首页
		if (token) {
			next('/')
		} else {
			next()
		}
		return
	}

	// 1. 不需要登录的页面，直接放行
	if (!needLogin) {
		next()
	}
	// 2. 需要登录的页面
	else {
		if (token) {
			// 有token直接访问
			next()
		} else {
			// 无token跳转登录，携带回跳地址
			next({
				path: '/login',
				query: {
					redirect: to.fullPath
				}
			})
		}
	}
})